import { useCallback } from 'react';

import * as helpers from '../helpers';
import * as actions from '../store/actions';
import { ANOTHER_PERIOD_VALUE } from '../constants';
import { useDynamicReducerDispatch } from '../store';

export const useOnFilterChange = () => {
    const dispatch = useDynamicReducerDispatch();

    return useCallback((event) => {
        const { name, value } = event.target;

        switch (name) {
            case 'limitType':
                dispatch(actions.updateLimitType(value));

                break;
            case 'period': {
                const periodValue = Number(value);

                dispatch(actions.updatePeriod(periodValue));
                dispatch(actions.updateFrom(helpers.getInitialFromDate()));

                if (periodValue !== ANOTHER_PERIOD_VALUE) {
                    dispatch(actions.updateStartDate(helpers.getStartDate(periodValue)));
                }

                break;
            }

            default:
                break;
        }
    }, [dispatch]);
};
